/** @format */

import { format as fnFormat, formatDistanceToNowStrict, intervalToDuration, isValid, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { vi } from 'date-fns/locale';
import {
  isBoolean,
  isInteger,
  isNumber,
  isString,
  map,
  parseInt,
  pick,
  replace,
  round,
  snakeCase,
  split,
  toLower,
  toNumber,
  trim,
  trimEnd
} from 'lodash';
import { isDate, isEmptyValue, isTimestamp } from './check.js';

export const getDateString = (value, format = 'dd MM yyyy') => {
  let formatValue = value;
  // if (typeof value === 'string' && value.length > 0) {
  //   const [datetime] = split(value.toString(), '.', 1);
  //   formatValue = new Date(datetime.replace(/-/g, '/'));
  // }

  if (typeof value === 'string' && value.length > 0) {
    // const [datetime] = split(value.toString(), '.', 1);
    formatValue = new Date(value); // ❌ Không dùng replace(/-/g, '/') nữa
  }

  console.log('getDateString', value, formatValue, formatDateUTC(formatValue));
  return isDate(formatValue) ? formatDateUTC(formatValue, format) : '';
};

export const formatTimestampToDate = (value, format = 'dd MM yyyy') => {
  if (isTimestamp(value)) {
    return fnFormat(value.toDate(), format);
  }

  return '';
};
export const formatDateUTC = (value, format = 'dd MM yyyy', timeZone = 'Asia/Ho_Chi_Minh') => {
  if (!isDate(value)) {
    return '';
  }
  const date = new Date(value); // Date sẽ tự động nhận diện nếu là UTC
  return formatInTimeZone(date, timeZone, format);
};
export const toTimestamp = (value) => {
  if (!value) return null; // Trả về null nếu giá trị là null hoặc undefined

  // Nếu đã là timestamp (số nguyên), trả về giá trị gốc
  if (typeof value === 'number') return value;

  // Nếu là đối tượng Date và hợp lệ, chuyển đổi sang timestamp
  if (isDate(value) && isValid(value)) {
    return value.getTime();
  }

  // Nếu là chuỗi ISO string hợp lệ, parse và chuyển sang timestamp
  if (typeof value === 'string') {
    const parsedDate = parseISO(value);
    if (isValid(parsedDate)) {
      return parsedDate.getTime();
    }
  }

  // Nếu không chuyển đổi được, trả về null
  return null;
};

export const parseJsonString = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
};

export const parseBoolean = (value) => {
  switch (value) {
    case 'true':
    case true:
    case 1:
      return true;
    case 'false':
    case false:
    case 0:
      return false;
    default:
      return value;
  }
};

export const removeCountryCode = (phoneNumber) => {
  return replace(phoneNumber, /^\+084|^\+84/, '');
};

// /**
//  * @typedef {Object<string, any>} DefaultValues
//  */

// /**
//  * @typedef {Partial<DefaultValues>} RecordValues
//  */

// /**
//  * Merges the default values with the record values.
//  * If a value exists in the record, it will be used; otherwise, the default value will be kept.
//  *
//  * @param {DefaultValues} defaultValues
//  * @param {RecordValues} record
//  * @returns {DefaultValues}
//  */
// export function mergeDefaultWithRecord(defaultValues, record) {
//   return mergeWith({}, defaultValues, record, (objValue, srcValue) => {
//     return isUndefined(srcValue) ? objValue : srcValue;
//   });
// }

/**
 * Merges the default values with the record values.
 * Only keys present in defaultValues will be included from the record.
 *
 * @param {Object<string, any>} defaultValues
 * @param {Object<string, any>} record
 * @returns {Object<string, any>}
 */
export function mergeDefaultWithRecord(defaultValues, record) {
  // Pick only the keys from record that exist in defaultValues
  const pickedRecord = pick(record, Object.keys(defaultValues));

  // Merge the default values with the picked values from record
  return {
    ...defaultValues,
    ...pickedRecord
  };
}

/**
 * formatMoney
 * @param money
 * @returns
 */
export const formatMoney = (number, prefix = '') => {
  let moneyFormat = '';
  if (typeof number === 'string' || typeof number === 'number') {
    const splitStr = split(number.toString(), '.');
    const strNumber = splitStr[0];

    if (!isEmptyValue(strNumber)) {
      moneyFormat = new Intl.NumberFormat('en-US').format(parseInt(strNumber));

      const minorUnit = trimEnd(splitStr[1], '0');
      if (!isEmptyValue(minorUnit)) {
        moneyFormat = `${moneyFormat}.${minorUnit}`;
      }
      if (moneyFormat) {
        moneyFormat = `${moneyFormat}${prefix}`;
      }
    }
  }

  return moneyFormat;
};

/**
 * formatMoneyVnd
 * @param money
 * @returns
 */
export const formatMoneyVnd = (money, prefix = '') => {
  let moneyFormat = formatMoney(money, prefix);
  if (moneyFormat) {
    moneyFormat = `${moneyFormat} ₫`;
  }
  return moneyFormat;
};

/**
 * round5
 * @param {*} number
 * @returns
 */
export const round5 = (number) => {
  return Math.ceil(number / 5) * 5;
};

/**
 *roundMoney
 * @param {*} total
 * @returns
 */
export const roundMoney = (total) => {
  return round(total, -5);
};

export const convertToBoolean = (val) => {
  if (!isString(val) && !isBoolean(val) && !isNumber(val)) {
    return undefined;
  }

  if (val === true || val === 1 || toLower(`${val}`) === 'true') {
    return true;
  }
  return false;
};

/**
 * valueToNumber
 * @param {*} value
 * @param {*} init
 * @returns
 */
export const valueToNumber = (value, init = 0) => {
  let number = toNumber(value);
  if (isNumber(number)) {
    return number;
  }

  return init;
};

/**
 * valueToInteger
 * @param {*} value
 * @param {*} init
 * @returns
 */
export const valueToInteger = (value, init = 0) => {
  let number = parseInt(value);
  if (isInteger(number)) {
    return number;
  }

  return init;
};

/**
 * formatDurationTime
 * @param {*} seconds
 */
export const formatDurationTime = (timeArray) => {
  const totalSeconds = timeArray.reduce((acc, time) => acc + time, 0);

  const duration = intervalToDuration({ start: 0, end: totalSeconds * 1000 });

  // Tính tổng số giờ
  const totalHours = (duration.days || 0) * 24 + (duration.hours || 0);

  // Chuẩn bị chuỗi giờ và phút
  const hourString = totalHours > 0 ? `${totalHours} giờ ` : '';
  const minuteString = duration.minutes > 0 ? `${duration.minutes} phút` : '0 phút';

  // Tạo chuỗi kết quả
  const durationString = `${hourString}${minuteString}`;
  return durationString.trim();
};

export const formatDistanceToNow = (date, suffix = '') => {
  return formatDistanceToNowStrict(date, { locale: vi }) + ' ' + suffix;
};

/**
 * convertMeterToKilometer
 * @param unit metter
 * @returns kilometer
 */
export const convertMeterToKilometer = (unit) => {
  return unit / 1000;
};

export const transToSnakeCase = (str) => {
  let result = '';

  if (str.length > 0) {
    const deburrStr = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    result = snakeCase(toLower(deburrStr));
  }

  return trim(result, '_');
};

// Hàm tạo giá trị RGB tươi sáng nhưng không quá đậm hoặc nhạt
const generateBrightRGBValue = () => {
  // Khoảng giá trị trung tính, tươi sáng (150-220)
  return Math.floor(Math.random() * (220 - 150) + 150);
};

// Hàm kiểm tra độ sáng của màu (luminance) để tránh màu không phù hợp
const isReadableWithWhiteText = (r, g, b) => {
  // Công thức tính độ sáng (luminance) theo chuẩn WCAG
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  // Đảm bảo màu không quá sáng (> 0.9) hoặc quá tối (< 0.4)
  return luminance > 0.4 && luminance < 0.9;
};

// Hàm tạo màu nền tươi sáng phù hợp cho chữ trắng
export const generateLabelBackgroundColor = () => {
  let r, g, b;

  // Lặp lại cho đến khi tìm được màu phù hợp
  do {
    r = generateBrightRGBValue();
    g = generateBrightRGBValue();
    b = generateBrightRGBValue();
  } while (!isReadableWithWhiteText(r, g, b)); // Kiểm tra độ sáng

  // Chuyển đổi RGB sang mã màu HEX
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

// Helper function to get blocked date ranges

export const getBlockedDates = (records, key = { start: 'start', end: 'end' }) => {
  return map(records, (record) => ({
    startDate: new Date(record[key['start']]),
    endDate: new Date(record[key['end']])
  })).sort((a, b) => a.startDate - b.startDate); // Sắp xếp theo startDate tăng dần
};

export const getStartInDates = (highlightedDays) => {
  return highlightedDays
    .map(({ endDate }) => new Date(endDate)) // Chuyển endDate thành Date object
    .filter((endDateCheck, index) => {
      return highlightedDays.every(({ startDate: rangeStart, endDate: rangeEnd }, i) => {
        // Bỏ qua mục đang kiểm tra (index === i)
        if (index === i) {
          return true;
        }

        const rangeStartDate = new Date(rangeStart);
        const rangeEndDate = new Date(rangeEnd);

        // Nếu là cùng ngày (startDate === endDate), kiểm tra xem endDateCheck có trùng không
        if (rangeStartDate.getTime() === rangeEndDate.getTime()) {
          return endDateCheck.getTime() !== rangeStartDate.getTime(); // Loại bỏ nếu trùng
        }

        // Nếu thuộc khoảng (startDate -> endDate), loại bỏ
        if (endDateCheck >= rangeStartDate && endDateCheck <= rangeEndDate) {
          return false;
        }

        return true; // Không thuộc khoảng nào
      });
    });
};

export const convertFromE164 = (phone) => {
  // Kiểm tra nếu số điện thoại bắt đầu với '+84'
  if (phone.startsWith('+84')) {
    // Loại bỏ '+84' và thêm '0' vào đầu
    return `0${phone.slice(3)}`;
  }

  // Nếu không phải định dạng E.164, trả về số ban đầu
  return phone;
};

// // có thê khởi hành cùng ngày start mà có ngày end trong ngày
// export const getStartInDates = (highlightedDays) => {
//   return highlightedDays
//     .map(({ endDate }) => {
//       startCheckDate: new Date(startDate);
//       endDateCheck: new Date(endDate);
//     }) // Chuyển endDate thành Date object
//     .filter(({ startCheckDate, endDateCheck }) => {
//       return highlightedDays.every(({ startDate: rangeStart, endDate: rangeEnd }) => {
//         const rangeStartDate = new Date(rangeStart);
//         const rangeEndDate = new Date(rangeEnd);

//         if (startCheckDate.getTime() === endDateCheck.getTime()) {

//         }

//         // Nếu là cùng ngày (startDate === endDate), kiểm tra xem endDateCheck có trùng không
//         if (rangeStartDate.getTime() === rangeEndDate.getTime()) {
//           return endDateCheck.getTime() === rangeStartDate.getTime(); // Chỉ giữ lại nếu trùng
//         }

//         return false; // Không thuộc khoảng nào
//       });
//     });
// };
